import useDictionary from "../../hooks/useDictionary";

//import { useParams } from "react-router-dom";
import { useState } from "react";

export default function S1B2BRegistrationForm({ onSuccess }) {

    const dictionary = useDictionary();
    
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(false);
    
    //const params = useParams();

    const [formData, setFormData] = useState({
        companyName: "",
        companyVatNumber: "",
        companyCountryName: "",
        companyCityName: "",
        firstName: "",
        lastName: "",
        streetName: "",
        streetNumber: "",
        zipCode: "",
        emailAddress: "",
        phoneNumber: "",
        companyType: "",
        accept1: false,
        accept2: false,
        tokenValue: ""
    });

    const validateField = (name, value) => {
        switch (name) {
            case "companyName":       return value.trim() ? undefined : dictionary.ERR_NO_COMP_NAME;
            case "companyVatNumber":  return value.trim() ? undefined : dictionary.ERR_NO_VAT_NUMBER;
            case "companyCityName":   return value.trim() ? undefined : dictionary.ERR_NO_CITY_NAME;
            case "companyCountryName":return value ? undefined : dictionary.ERR_NO_COUNTRY_SEL;
            case "companyType":       return value ? undefined : dictionary.ERR_NO_COMPANY_TYPE;
            case "firstName":         return value.trim() ? undefined : dictionary.ERR_NO_NAME;
            case "lastName":          return value.trim() ? undefined : dictionary.ERR_NO_LASTNAME;
            case "zipCode":         return value.trim() ? undefined : dictionary.ERR_NO_ZIPCODE;
            case "streetName":         return value.trim() ? undefined : dictionary.ERR_NO_STREET_NAME;
            case "streetNumber":         return value.trim() ? undefined : dictionary.ERR_NO_STREET_NO;
            case "emailAddress":      return value.includes("@") ? undefined : dictionary.ERR_NO_EMAIL;
            case "phoneNumber":       return value.trim() ? undefined : dictionary.ERR_NO_PHONE;
            case "accept1":           return value ? undefined : dictionary.ERR_CONSENT;
            case "accept2":           return value ? undefined : dictionary.ERR_NO_AGREE;
            case "tokenValue":         return value.trim() ? undefined : dictionary.ERR_NO_TOKEN;
            default:                  return undefined;
        }
    };

    const validate = () => {
        const newErrors = {};
        Object.entries(formData).forEach(([name, value]) => {
            const error = validateField(name, value);
            if (error) newErrors[name] = error;
        });
        return newErrors;
    };    

    const hasErrors = Object.values(errors).some(e => e !== undefined);

    const handleChange = (e) => {
        
        const { name, value, type, checked } = e.target;
        const newValue = type === "checkbox" ? checked : value;

        setFormData(prev => ({ ...prev, [name]: newValue }));

        if (errors[name] !== undefined) {
            setErrors(prev => ({ ...prev, [name]: validateField(name, newValue) }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log(validationErrors);
            setLoading(false);
            return;
        }

        setApiError(false);
        setErrors({});

        try {

            const response = await fetch("https://api.negativbrand.com/pl/api/registerb2bmerchant", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });            

            console.log(response);

            if (!response.ok) throw new Error("Server API error");

            const data = await response.json();
            console.log("Zarejestrowano:", data);

            if (data['status'] === 'ok') { onSuccess(data['user_id'], data['user_hash']); } else {
                
                if (data['error'] === 'token_error') { setErrors(prev => ({ ...prev, tokenValue: dictionary.WRONG_TOKEN })); }
                setApiError(true);

            }

            //navigate(`/${params.lang}/b2b-reg-form/done`);

        } catch (err) {
            setApiError(true);
        } finally {
            setLoading(false);
        }

    }

    return (
        <>
        <div>
                <div className={`overlay-loading ${loading ? '' : 'default-hidden'}`}><span className="loader"><span>{dictionary.WAIT_A_SECOND}</span></span><div className="shadow"></div></div>

                <div className="univ-form-header">
                    {dictionary.COMPANY_DATA}
                </div>

                <div className="univ-form-fields">

                    <div className="univ-form-field">
                        <label>{dictionary.COMPANY_NAME}<span>*</span></label>
                        {errors.companyName && <span style={{ color: "red" }}>{errors.companyName}</span>}
                        <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>NIP / VAT UE<span>*</span></label>
                        {errors.companyVatNumber && <span style={{ color: "red" }}>{errors.companyVatNumber}</span>}
                        <input type="text" placeholder={`${dictionary.EXAMPLE}: PL7331290550`} name="companyVatNumber" value={formData.companyVatNumber} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.DEST_COUNTRY}<span>*</span></label>
                        {errors.companyCountryName && <span style={{ color: "red" }}>{errors.companyCountryName}</span>}
                        <select name="companyCountryName" value={formData.companyCountryName} onChange={handleChange}>
                            
                            <option value="">- {dictionary.SELECT} -</option>

                            <option value="PL">Polska / Poland</option>
                            <option value="DE">Niemcy / Germany</option>
                            <option value="CZ">Czechy / Czech Republic</option>
                            <option value="SK">Słowacja / Slovakia</option>
                            <option value="AT">Austria / Austria</option>
                            <option value="HU">Węgry / Hungary</option>
                            <option value="LT">Litwa / Lithuania</option>
                            <option value="LV">Łotwa / Latvia</option>
                            <option value="EE">Estonia / Estonia</option>
                            <option value="UA">Ukraina / Ukraine</option>

                            <option value="GB">Wielka Brytania / United Kingdom</option>
                            <option value="IE">Irlandia / Ireland</option>
                            <option value="FR">Francja / France</option>
                            <option value="ES">Hiszpania / Spain</option>
                            <option value="PT">Portugalia / Portugal</option>
                            <option value="IT">Włochy / Italy</option>
                            <option value="NL">Holandia / Netherlands</option>
                            <option value="BE">Belgia / Belgium</option>
                            <option value="LU">Luksemburg / Luxembourg</option>
                            <option value="DK">Dania / Denmark</option>
                            <option value="SE">Szwecja / Sweden</option>
                            <option value="NO">Norwegia / Norway</option>
                            <option value="FI">Finlandia / Finland</option>
                            <option value="CH">Szwajcaria / Switzerland</option>

                            <option value="RO">Rumunia / Romania</option>
                            <option value="BG">Bułgaria / Bulgaria</option>
                            <option value="HR">Chorwacja / Croatia</option>
                            <option value="SI">Słowenia / Slovenia</option>
                            <option value="RS">Serbia / Serbia</option>
                            <option value="BA">Bośnia i Hercegowina / Bosnia and Herzegovina</option>
                            <option value="ME">Czarnogóra / Montenegro</option>
                            <option value="MK">Macedonia Północna / North Macedonia</option>
                            <option value="AL">Albania / Albania</option>
                            <option value="GR">Grecja / Greece</option>

                            <option value="US">Stany Zjednoczone / United States</option>
                            <option value="CA">Kanada / Canada</option>
                            <option value="MX">Meksyk / Mexico</option>

                            <option value="CN">Chiny / China</option>
                            <option value="JP">Japonia / Japan</option>
                            <option value="KR">Korea Południowa / South Korea</option>
                            <option value="IN">Indie / India</option>

                            <option value="AU">Australia / Australia</option>
                            <option value="NZ">Nowa Zelandia / New Zealand</option>

                        </select>
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.COMPANY_TYPE}<span>*</span></label>
                        {errors.companyType && <span style={{ color: "red" }}>{errors.companyType}</span>}
                        <select name="companyType" value={formData.companyType} onChange={handleChange}>
                            <option>- {dictionary.SELECT} -</option>
                            <option value="JDG">{dictionary.JDG_COMPANY}</option>
                            <option value="ZOO">{dictionary.LLC_COMPANY}</option>
                            <option value="OUTSIDE">{dictionary.OUT_COMPANY}</option>
                            <option value="OTHER">{dictionary.OTHER}</option>
                        </select>
                    </div>

                </div>

                <div className="univ-form-header">
                    {dictionary.STORE_ADDRESS}
                </div>    

                <div className="univ-form-fields">

                    <div className="univ-form-field">
                        <label>{dictionary.ZIP_CODE}<span>*</span></label>
                        {errors.zipCode && <span style={{ color: "red" }}>{errors.zipCode}</span>}
                        <input type="text" name="zipCode" value={formData.zipCode} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.SALE_CITY_NAME}<span>*</span></label>
                        {errors.companyCityName && <span style={{ color: "red" }}>{errors.companyCityName}</span>}
                        <input type="text" name="companyCityName" value={formData.companyCityName} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.STREET_NAME}<span>*</span></label>
                        {errors.streetName && <span style={{ color: "red" }}>{errors.streetName}</span>}
                        <input type="text" name="streetName" value={formData.streetName} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.STREET_NUMBER}<span>*</span></label>
                        {errors.streetNumber && <span style={{ color: "red" }}>{errors.streetNumber}</span>}
                        <input type="text" name="streetNumber" value={formData.streetNumber} onChange={handleChange} />
                    </div>

                </div>

                <div className="univ-form-header">
                    {dictionary.CONTACT_PERSON}
                </div>                

                <div className="univ-form-fields">

                    <div className="univ-form-field">
                        <label>{dictionary.NAME}<span>*</span></label>
                        {errors.firstName && <span style={{ color: "red" }}>{errors.firstName}</span>}
                        <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.LASTNAME}<span>*</span></label>
                        {errors.lastName && <span style={{ color: "red" }}>{errors.lastName}</span>}
                        <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.EMAIL_ADDRESS}<span>*</span></label>
                        {errors.emailAddress && <span style={{ color: "red" }}>{errors.emailAddress}</span>}
                        <input type="email" name="emailAddress" value={formData.emailAddress} onChange={handleChange} />
                    </div>

                    <div className="univ-form-field">
                        <label>{dictionary.PHONE_NUMBER}<span>*</span></label>
                        {errors.phoneNumber && <span style={{ color: "red" }}>{errors.phoneNumber}</span>}
                        <input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} />
                    </div>

                </div>

                <div className="univ-form-header">
                    {dictionary.VERIFICATION}
                </div> 

                <div className="univ-form-fields">

                    <div className="antispam">
                        {errors.tokenValue && <div style={{ color: "red" }}>{errors.tokenValue}</div>}
                        <div>
                            <label>{dictionary.CAPTCHA_VER}<span>*</span></label>
                            <img alt="Captcha" src="https://store.negativbrand.com/pl/antispam" />
                            <input type="text" name="tokenValue" value={formData.tokenValue} onChange={handleChange} />
                        </div>
                    </div>

                </div>

                <div className="univ-form-header">
                    {dictionary.CONSENTS}
                </div> 

                {errors.accept1 && <div style={{ color: "red", textAlign: "center" }}>{errors.accept1}</div>}
                <div className="univ-form-checkbox">
                        <input type="checkbox" id="accept1" name="accept1" value={formData.accept1} onChange={handleChange} />
                        <label htmlFor="accept1">{dictionary.AGREE1}<span>*</span></label>
                </div>

                {errors.accept2 && <div style={{ color: "red", textAlign: "center" }}>{errors.accept2}</div>}
                <div className="univ-form-checkbox">
                        <input type="checkbox" id="accept2" name="accept2" value={formData.accept2} onChange={handleChange} />
                        <label htmlFor="accept2">{dictionary.AGREE2}<span>*</span></label>
                </div>

                <div className="univ-submit-button">
                    {apiError && <div style={{ color: "red", padding: "1rem" }}>{dictionary.SERVER_ERROR} :-(</div>}
                    {hasErrors && (
                        <p style={{ color: "red" }}>{dictionary.FORM_ERROR}</p>
                    )}
                    <button onClick={handleSubmit} disabled={loading}>{loading ? dictionary.REG_IN_PROGRESS : dictionary.REG_BUTTON }</button>
                </div>

        </div>

        </>
    )

}